export const IndividualsIcon = (props) => (
  <svg
    width="27"
    height="30"
    viewBox="0 0 27 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.125 15C15.1141 15 17.0218 14.2098 18.4283 12.8033C19.8348 11.3968 20.625 9.48912 20.625 7.5C20.625 5.51088 19.8348 3.60322 18.4283 2.1967C17.0218 0.790176 15.1141 0 13.125 0C11.1359 0 9.22822 0.790176 7.8217 2.1967C6.41518 3.60322 5.625 5.51088 5.625 7.5C5.625 9.48912 6.41518 11.3968 7.8217 12.8033C9.22822 14.2098 11.1359 15 13.125 15ZM10.4473 17.8125C4.67578 17.8125 0 22.4883 0 28.2598C0 29.2207 0.779297 30 1.74023 30H24.5098C25.4707 30 26.25 29.2207 26.25 28.2598C26.25 22.4883 21.5742 17.8125 15.8027 17.8125H10.4473Z"
      fill="#2E7D32"
    />
  </svg>
);

export default IndividualsIcon;
